<template>
  <span :hidden="!isAdminStatus">
      <a
          :aria-expanded="troubleCollaps"
          class="sidebar-menu-item nav-link"
          data-toggle="collapse"
          @click="(troubleCollaps=!troubleCollaps)"
      >
          <template>
              <i class="fa pr-2 fa-tools text-indigo"></i>
              <span class="nav-link-text">Troubleshooting<b class="caret"></b></span>
          </template>
      </a>
      <collapse-transition :duration="{enter: 500, leave: 500}">
          <div v-show="troubleCollaps" id="collapse-just" :class="troubleCollaps?'show':''" class="collapse">
              <ul class="nav nav-sm flex-column">
                <!-- <slot v-for="(item, index) in troubleLinks" name="title">
                      <router-link
                          :key="index"
                          :target="item.url"
                          class="nav-link"
                          :href="item.url"
                          :to="item.url"
                          @click.native="linkClick"
                      >
                          <template>
                              <i :class="`${item.icon} text-${item.color} pr-2`"></i>
                              <span class="nav-link-text">{{ item.label }}</span>
                          </template>
                      </router-link>
                  </slot> -->
                  <!-- <router-link class="nav-link" to="/graphing">
                    <i class="fa fa-cogs text-" font-scale="1"></i>
                    Diameter Usage Graphing
                  </router-link> -->
                  <a class="nav-link" href="http://10.56.0.108/enum/" target="_blank">
                    <i class="fa fa-signal text-green" font-scale="1"></i>
                    ENUM Status
                  </a>
                  <a class="nav-link" href="http://10.57.0.50/otz/cwstats.php" target="_blank">
                    <i class="fa fa-chart-area text-indigo" font-scale="1"></i>
                    IMS KIP Graphing
                  </a>
                  <a class="nav-link" href="http://10.57.0.50/otz/subscriber-status.php" target="_blank">
                    <i class="fa fa-user text" font-scale="1"></i>
                    IMS Subscriber Status
                  </a>
                  <!-- <a class="nav-link" to="/aaa_log_download">
                    <i class="fa fa-cog text-blue" font-scale="1"></i>
                    AAA Log Download
                  </a> -->
                  <a class="nav-link" href="http://198.140.29.21:1785/log-search.php" target="_blank">
                    <i class="fa fa-envelope text-blue" font-scale="1"></i>
                    SMS Router Logs
                  </a>
                  <!-- <a class="nav-link" to="/aaa_log_search">
                    <i class="fa fa-digital-tachograph text-indigo" font-scale="1"></i>
                    AAA Log Search
                  </a> -->
                  <!-- <a class="nav-link" to="/broadband_graphs">
                    <i class="fa fa-chart-area text-green" font-scale="1"></i>
                    OTZ Broadband Graphs
                  </a> -->
                  <!-- <a class="nav-link" to="/roaming_heatmap">
                    <i class="fa fa-map-marked text-yellow" font-scale="1"></i>
                    OTZ Roaming Heatmap
                  </a> -->
                  <router-link class="nav-link" to="/overwatch">
                    <i class="fa fa-cogs text-red" font-scale="1"></i>
                    Overwatch
                  </router-link>
                  <a class="nav-link" href="http://10.57.0.50/otz/custom/sms-mt.php" target="_blank">
                    <i class="fa fa-mail-bulk text-purple" font-scale="1"></i>
                    SMS MT Queue
                  </a>
                  <a class="nav-link" href="http://10.57.0.50/otz/sms.php" target="_blank">
                    <i class="fa fa-file-invoice text-blue" font-scale="1"></i>
                    SMS Subscriber Tracing
                  </a>
                  <router-link class="nav-link" to="/serviceassurance">
                    <i class="fa fa-tools text-orange" font-scale="1"></i>
                    Service Assurance
                  </router-link>
                </ul>
              </div>
        </collapse-transition>
      </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import configDirective from "@/common/directive/config-directive";
import initService from "../../../common/api-services/init-service";

export default {
name: 'side-trouble-custom-group',
components: {
  CollapseTransition
},
data() {
  return {
    isAdminStatus: false,
    groups: [],
    troubleLinks: [],
    troubleCollaps: false,
  }
},
mounted() {
  // this.troubleLinks = configDirective.getTroubleLinks();
  //console.log('trouble:', this.troubleLinks);
  this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
},
methods: {
  linkClick() {
    if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
    ) {
      this.$sidebar.displaySidebar(false);
    }
  },
}
}
</script>